// extracted by mini-css-extract-plugin
export default {"languagesWrapper":"Languages_languagesWrapper__Rij4L","tittle":"Languages_tittle__8YF+V","language":"Languages_language__Z1B32","lvl":"Languages_lvl__FNGDI"};